// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__12JF0","item":"Badge_item__xDUBi"};